<template>
  <v-row>
    <v-col
      v-for="chart in statisticCharts"
      :key="chart.chartData.datasets.label"
      cols="12"
      sm="6"
    >
      <base-material-chart-js-card
        :chart-data="chart.chartData"
        :options="chart.options"
        color="#ffffff"
        hover-reveal
      >
        <template #reveal-actions>
          <v-tooltip bottom>
            <template #activator="{ attrs, on }">
              <v-btn
                v-bind="attrs"
                color="info"
                icon
                v-on="on"
              >
                <v-icon
                  color="info"
                >
                  mdi-refresh
                </v-icon>
              </v-btn>
            </template>

            <span>{{ $t('statistics.Refresh') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ attrs, on }">
              <v-btn
                v-bind="attrs"
                light
                icon
                v-on="on"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>

            <span>{{ $t('statistics.ChangeDate') }}</span>
          </v-tooltip>
        </template>

        <h4 class="card-title font-weight-light mt-2 ml-2">
          {{ chart.title }}
        </h4>

        <p class="d-inline-flex font-weight-light ml-2 mt-1">
          {{ chart.subtitle }}
        </p>

        <template #actions>
          <v-icon
            class="mr-1"
            small
          >
            mdi-clock-outline
          </v-icon>
          <span class="caption grey--text font-weight-light">{{ updateDate }}</span>
        </template>
      </base-material-chart-js-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import { germanDateFormater } from '@/utils/germanDateFormater'
  import monthRangeFromBegin from '@/utils/monthRangeFromBegin'

  export default {
    name: 'Statistics',
    // components: {
    //   StatisticChart,
    // },
    props: ['customerStats'],
    data: () => ({
      title: 'Zuwachs Internationale Kunden',
      // chartSeriesAll: [],
      statisticCharts: [],
    }),
    computed: {

      updateDate () {
        const day = new Date(Date.now())
        return `${this.$t('updated')}: ${germanDateFormater(day)}`
      },
      daysInCurrentMonth () {
        return Array.from({ length: moment(moment().month()).daysInMonth() }, (x, i) => moment().startOf('month').add(i, 'days').format('DD.MM'))
      },
    },
    watch: {
      chartData () {
        this.$data._chart.update()
      },
    },
    mounted () {
      this.loadDataSeries()
    },
    methods: {
      async loadDataSeries () {
        this.chartSeriesRamDomainByMonth = this.customerStats.ramDomainCountByMonth
        this.chartSeriesLawFirmByMonth = this.customerStats.lawFirmCountByMonth
        this.chartSeriesGermanVofDomainByMonth = this.customerStats.germanVofDomainCountByMonth
        this.chartSeriesForeignVofDomainByMonth = this.customerStats.foreignVofDomainCountByMonth
        this.statisticCharts = [
          {
            chartData: {
              labels: monthRangeFromBegin(),
              datasets: [
                {
                  label: 'Zuwachs Deutsche Rechtsanwälte RA-MICRO Kunden',
                  backgroundColor: 'transparent',
                  borderColor: '#cc0000',
                  pointBackgroundColor: 'white',
                  pointBorderColor: '#cc0000',
                  borderWidth: 3,
                  data: this.chartSeriesRamDomainByMonth,
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                  },
                }],
              },
            },
            title: 'Zuwachs Deutsche Rechtsanwälte',
            subtitle: 'RA-MICRO Kunden',
          },
          {
            chartData: {
              labels: monthRangeFromBegin(),
              datasets: [
                {
                  label: 'Zuwachs Deutsche Rechtsanwälte nicht RA-MICRO Kunden',
                  backgroundColor: 'transparent',
                  borderColor: 'green',
                  pointBackgroundColor: 'white',
                  pointBorderColor: 'green',
                  borderWidth: 3,
                  data: this.chartSeriesLawFirmByMonth,
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                  },
                }],
              },
            },
            title: 'Zuwachs Deutsche Rechtsanwälte',
            subtitle: 'nicht RA-MICRO Kunden',
          },
          {
            chartData: {
              labels: monthRangeFromBegin(),
              datasets: [
                {
                  label: 'Zuwachs Deutsche Unternehmen (=alle nicht Rechtsanwälte)',
                  backgroundColor: 'transparent',
                  borderColor: 'blue',
                  pointBackgroundColor: 'white',
                  pointBorderColor: 'blue',
                  borderWidth: 3,
                  data: this.chartSeriesGermanVofDomainByMonth,
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,
                  },
                }],
              },
            },
            title: 'Zuwachs Deutsche Unternehmen',
            subtitle: '(=alle nicht Rechtsanwälte)',
          },
          {
            chartData: {
              labels: monthRangeFromBegin(),
              datasets: [
                {
                  label: 'Zuwachs Internationale Kunden (gesamt)',
                  backgroundColor: 'transparent',
                  borderColor: 'purple',
                  pointBackgroundColor: 'white',
                  pointBorderColor: 'purple',
                  borderWidth: 3,
                  data: this.chartSeriesForeignVofDomainByMonth,
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true,

                  },
                }],
              },
            },
            title: 'Zuwachs Ausländische Kunden',
            subtitle: '(gesamt)',
          },
        ]
      },
    },
  }
</script>
